import React from 'react';
import { LeadTypeBadge } from '../LeadTypeBadge';

export const AdminVendedorLeadsModal = ({
  isOpen,
  selectedVendedor,
  leads,
  onClose,
  onDeleteLead,
}) => {
  if (!isOpen || !selectedVendedor) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="admin-vendedores-leads-modal-overlay">
      <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col" data-testid="admin-vendedores-leads-modal">
        <div className="p-6 border-b">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-bold text-gray-900" data-testid="admin-vendedores-leads-modal-title">
              Leads de {selectedVendedor.nome}
            </h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-testid="admin-vendedores-close-leads-modal-button">
              ✕
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-6" data-testid="admin-vendedores-leads-modal-content">
          {leads.length === 0 ? (
            <div className="text-center text-gray-500 py-8" data-testid="admin-vendedores-empty-leads-state">
              Nenhum lead registrado ainda.
            </div>
          ) : (
            <div className="space-y-4" data-testid="admin-vendedores-leads-list">
              {leads.map((lead) => (
                <div key={lead.id} className="border rounded-lg p-4" data-testid={`admin-vendedores-lead-card-${lead.id}`}>
                  <div className="flex items-start justify-between">
                    <div>
                      <div className="font-medium text-gray-900" data-testid={`admin-vendedores-lead-name-${lead.id}`}>{lead.cliente_nome}</div>
                      <div className="text-sm text-gray-600" data-testid={`admin-vendedores-lead-email-${lead.id}`}>{lead.cliente_email}</div>
                      {lead.cliente_telefone && (
                        <div className="text-sm text-gray-600" data-testid={`admin-vendedores-lead-phone-${lead.id}`}>{lead.cliente_telefone}</div>
                      )}
                    </div>
                    <LeadTypeBadge type={lead.tipo} withIcon className="px-2 py-1 rounded text-xs font-medium" />
                  </div>
                  <div className="text-xs text-gray-400 mt-2" data-testid={`admin-vendedores-lead-created-at-${lead.id}`}>
                    {new Date(lead.created_at).toLocaleString('pt-BR')}
                  </div>
                  <div className="mt-3 flex justify-end">
                    <button
                      type="button"
                      onClick={() => onDeleteLead(lead)}
                      className="px-3 py-2 rounded-lg bg-red-50 text-red-700 hover:bg-red-100 transition"
                      data-testid={`admin-vendedores-delete-lead-button-${lead.id}`}
                    >
                      Excluir lead
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
